// components/PasswordChange.vue
<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-900">Change Password</h1>
    </div>

    <!-- Error Message -->
    <div
      v-if="error"
      class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <strong class="font-bold">Error!</strong>
      <span class="block sm:inline">{{ error }}</span>
    </div>

    <!-- Success Message -->
    <div
      v-if="success"
      class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <strong class="font-bold">Success!</strong>
      <span class="block sm:inline"
        >Your password has been changed successfully.</span
      >
    </div>

    <div class="bg-white shadow-md rounded-lg p-6 max-w-md">
      <form @submit.prevent="handleSubmit" class="space-y-4">
        <div>
          <label
            for="current_password"
            class="block text-sm font-medium text-gray-700"
            >Current Password</label
          >
          <input
            type="password"
            id="current_password"
            v-model="form.current_password"
            required
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label
            for="new_password"
            class="block text-sm font-medium text-gray-700"
            >New Password</label
          >
          <input
            type="password"
            id="new_password"
            v-model="form.new_password"
            required
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label
            for="confirm_password"
            class="block text-sm font-medium text-gray-700"
            >Confirm New Password</label
          >
          <input
            type="password"
            id="confirm_password"
            v-model="form.confirm_password"
            required
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div class="flex gap-4">
          <button
            type="submit"
            :disabled="isLoading"
            class="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {{ isLoading ? "Changing Password..." : "Change Password" }}
          </button>
          <button
            type="button"
            @click="goBack"
            class="inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { changePassword } from "@/services/accountService";

export default {
  name: "PasswordChange",
  setup() {
    const router = useRouter();
    const error = ref("");
    const success = ref(false);
    const isLoading = ref(false);
    const form = ref({
      current_password: "",
      new_password: "",
      confirm_password: "",
    });

    const handleSubmit = async () => {
      error.value = "";
      success.value = false;

      if (form.value.new_password !== form.value.confirm_password) {
        error.value = "New passwords do not match";
        return;
      }

      isLoading.value = true;
      try {
        await changePassword({
          old_password: form.value.current_password,
          new_password: form.value.new_password,
        });
        success.value = true;
        // Redirect after successful password change
        setTimeout(() => {
          router.push({ name: "MyAccount" });
        }, 2000);
      } catch (err) {
        error.value =
          err.response?.data?.detail ||
          "Failed to change password. Please try again.";
      } finally {
        isLoading.value = false;
      }
    };

    const goBack = () => {
      router.push({ name: "MyAccount" });
    };

    return {
      form,
      error,
      success,
      isLoading,
      handleSubmit,
      goBack,
    };
  },
};
</script>
